export function UrlSearch() {
  let name; let value; const str = location.href; let num = str.indexOf('?') // 取得整个地址栏
  // str = str.substr(num + 1) // 取得所有参数 stringvar.substr(start [, length ]
  const newStr = str.substring(num + 1)
  const arr = newStr.split('&') // 各个参数放到数组里
  for (let i = 0; i < arr.length; i++) {
    num = arr[i].indexOf('=')
    if (num > 0) {
      name = arr[i].substring(0, num)
      value = arr[i].substr(num + 1)
      this[name] = value
    }
  }
}
